<template>
  <div class="col-span-6 md:col-span-3 lg:col-span-4">
    <NuxtLink :to="localePathByType(data.__typename, data.slug as string)" noPrefetch>
      <div class="relative">
        <div class="absolute bottom-10 right-10 z-2 hidden h-16 w-16 lg:block">
          <CircleButton class="!bg-none" icon-name="arrow-right" color="orange" />
        </div>
        <Image
          class="aspect-3/2 rounded-3xl object-cover lg:aspect-square"
          loading="lazy"
          :src="data?.image!.responsiveImage ? data?.image!.responsiveImage?.src : data?.image!.url"
          :srcset="
            data?.image!.responsiveImage ? data?.image!.responsiveImage?.webpSrcSet : undefined
          "
          :width="
            data?.image!.responsiveImage ? data?.image!.responsiveImage?.width : data?.image!.width
          "
          :height="
            data?.image!.responsiveImage
              ? data?.image!.responsiveImage?.height
              : data?.image!.height
          "
          sizes="(min-width: 1920px) 296px, (min-width: 1400px) 405px, (min-width: 1060px) calc(26.25vw + 43px), (min-width: 1020px) calc(-665vw + 7231px), (min-width: 780px) calc(37.27vw + 75px), (min-width: 520px) 448px, 90vw"
          :alt="data?.image!.alt!"
        />
      </div>
    </NuxtLink>
    <div class="mb-5 mt-4">
      <NuxtLink
        v-for="category in data.category"
        :key="category.id"
        :to="
          localePath({
            path: `/${paths[locale as LocaleCode][ModelApiKey.Article].path}`,
            query: { category: category.name }
          })
        "
        class="mr-2 rounded-full bg-light-gray px-3 py-[6px] text-xs text-blue-950 no-underline"
        >{{ category.name }}</NuxtLink
      >
    </div>
    <NuxtLink
      :to="localePathByType(data.__typename, data.slug as string)"
      class="text-xl text-blue-950"
      >{{ data.title }}</NuxtLink
    >
  </div>
</template>

<script setup lang="ts">
import { paths } from '~/lib/paths'
import type { ArticleRecord } from '~/types/generated'
import type { LocaleCode } from '~/types/locales'
import { ModelApiKey } from '~/types/models'

const { locale } = useI18n()
const localePath = useLocalePath()
const { localePathByType } = useLocalePathByType()

defineProps({
  data: {
    type: Object as PropType<ArticleRecord>,
    default: () => {}
  }
})
</script>
